import React from 'react';
import { Pressable, StyleSheet } from 'react-native';
import { useModalStore } from '@/store';
import { useTheme } from '@/context/ThemeContext';
import Text from '@/components/Typography/Text';
import Icon from '@/components/Icon';
import { getModelPricing } from '@/utils/model_pricing';

export default function ModelCreditsButton({ model, variant = 'default' }) {
  const { colors } = useTheme();
  const openModal = useModalStore(state => state.actions.openModal);
  const price = getModelPricing(model);
  if (!price) return null;

  return (
    <Pressable
      accessibilityRole="button"
      accessibilityLabel={`How credits work for ${model.name}. ${price.startingLabel}.`}
      onPress={event => {
        event?.stopPropagation?.();
        openModal('ModelCreditsModal', { model });
      }}
      style={({ hovered, pressed }) => [styles.button, variant === 'plain' && styles.plain, {
        backgroundColor: hovered || pressed ? colors.solid_color_tertiary : 'transparent',
      }]}
    >
      {variant !== 'plain' && <Icon name="coin" solid size={11} color={colors.text_color_secondary} />}
      <Text size="xs" color="secondary" weight="medium">{price.startingLabel}</Text>
      <Icon name="circle-info" size={12} color={colors.text_color_tertiary} />
    </Pressable>
  );
}

const styles = StyleSheet.create({
  button: { flexDirection: 'row', alignItems: 'center', alignSelf: 'flex-start', gap: 6, paddingHorizontal: 6, minHeight: 32, borderRadius: 6 },
  plain: { paddingHorizontal: 0 },
});
